import { graphql } from "babel-plugin-relay/macro";
import React from "react";
import { createFragmentContainer } from "react-relay";
import { AuditionVideoElement_element$data } from "../../__generated__/AuditionVideoElement_element.graphql";
import { AuditionVideoElement_screener$data } from "../../__generated__/AuditionVideoElement_screener.graphql";
import { CommonElementProps } from "./Element";
import { ElementBase } from "./index";

type Props = {
  element: AuditionVideoElement_element$data;
  screener: AuditionVideoElement_screener$data;
} & CommonElementProps;
const AuditionVideoElement: React.FC<Props> = props => <ElementBase {...props} />;

export default createFragmentContainer(AuditionVideoElement, {
  element: graphql`
    fragment AuditionVideoElement_element on ElementNode {
      ...ElementBase_element
    }
  `,
  screener: graphql`
    fragment AuditionVideoElement_screener on ScreenerNode {
      ...ElementBase_screener
    }
  `,
});
